import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import Branch from "models/branch"
import Department from "models/department"

// If you have a better typed model for the API response, swap this type.

export interface DepartmentBudgetsSliceState {
  budgets: Department[]
  isLoading: boolean
  departments: Department[]
  branches: Branch[]
}

export const initialState: DepartmentBudgetsSliceState = {
  budgets: [],
  isLoading: false,
  departments: [],
  branches: []
}

const subAccountBudgetsSlice = createSlice({
  name: "departmentBudgets",
  initialState,
  reducers: {
    setDepartmentBudgetsLoading(state, { payload }: PayloadAction<boolean>) {
      state.isLoading = payload
    },
    setDepartmentBudgets(state, { payload }: PayloadAction<Department[]>) {
      state.budgets = payload ?? []
    },
    setDepartmentBudgetSearchFields(state, { payload }: PayloadAction<{
      departments: Department[],
      branches: Branch[]
    }>) {
      state.branches = payload.branches;
      state.departments = payload.departments
    }
  },
})

export const {
  setDepartmentBudgetsLoading,
  setDepartmentBudgets,
  setDepartmentBudgetSearchFields,
} = subAccountBudgetsSlice.actions

export default subAccountBudgetsSlice.reducer